import React from 'react';
import { translate } from '../../utils';
import en from '../../languages/en.json';
import ru from '../../languages/ru.json';
import be from '../../languages/be.json';
import {
  monthRu,
  monthEn,
  monthBe,
  monthRuShort,
  monthEnShort,
  monthBeShort,
} from '../../languages/dayWeeks';
import { monthLangRu, monthLangEn, monthLangBe } from '../../languages/month';

export default class ChangeLang extends React.Component {
  constructor(props) {
    super();
    this.change = this.change.bind(this);
    this.props = props;
    this.state = {
      value: props.data.language,
    };
  }

  componentDidMount() {
    const { language } = this.props.data.language;
    switch (language) {
      case 'ru':
        translate(ru);
        break;
      case 'en':
        translate(en);
        break;
      case 'be':
        translate(be);
        break;
      default:
        break;
    }
  }

  getDataToTranslate() {
    const getLanguageDayWeeks = this.props.data.func;
    const { value } = this.state;
    if (value === 'ru') {
      getLanguageDayWeeks(monthRu, monthRuShort, monthLangRu, 'ru');
      translate(ru);
    }
    if (value === 'en') {
      getLanguageDayWeeks(monthEn, monthEnShort, monthLangEn, 'en');
      translate(en);
    }
    if (value === 'be') {
      getLanguageDayWeeks(monthBe, monthBeShort, monthLangBe, 'be');
      translate(be);
    }
  }

  change(event) {
    this.setState({ value: event.target.value }, () =>
      this.getDataToTranslate()
    );
  }

  render() {
    return (
      <select
        className="change-lang"
        onChange={this.change}
        value={this.props.data.language}
      >
        <option value="en">EN</option>
        <option value="ru">RU</option>
        <option value="be">BE</option>
      </select>
    );
  }
}
